import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';
import { PopupModalComponent } from '../../shared/popup-modal/popup-modal.component';

@Component({
  selector: 'vex-user-addon-detail',
  templateUrl: './user-addon-detail.component.html',
  styleUrls: ['./user-addon-detail.component.scss']
})
export class UserAddonDetailComponent implements OnInit {
  addon: any;
  purchaseSpinner: boolean = false;
  totalAmount: any = 0;

  constructor(public guiService: GuiService, public translate: TranslateService, private restService: RestService, public dialog: MatDialog) { }

  ngOnInit() {
    this.guiService.showSpinner = false;
    const item = JSON.parse(sessionStorage.getItem('addonDetail'));
    this.addon = item;
    this.purchaseSpinner = false;
    const price = parseFloat(this.addon.price) || 0;
    this.totalAmount = Number((price * this.addon.quantity.min).toFixed(2));
    this.addon.quantity.count = this.addon.quantity.min;
  }

  back() {
    if (this.addon.isSingleItem) {
      this.guiService.goTo('main/home');
    } else {
      this.guiService.goTo('main/addons');
    }
  }

  addQuantity(addon: any, sign: string) {
    const price = parseFloat(addon.price);
    if (sign === 'plus' && addon.quantity.count < addon.quantity.max) {
      addon.quantity.count++;
      this.totalAmount = Number((this.totalAmount + price).toFixed(2));
    } else if (sign === 'minus' && addon.quantity.count > addon.quantity.min) {
      addon.quantity.count--;
      this.totalAmount = Number((this.totalAmount - price).toFixed(2));
    }
  }

  openModalConfirmPurchase(item: any): void {

    const html = `
    ${this.translate.instant('ADDONS.POPUP_MSG_1')}
    <br>
    <ul>
      <li>
        ${item.i18nName[this.translate.currentLang.toUpperCase()]}
        (${this.translate.instant('ADDONS.QTY')}:${item.quantity.count})
        - <span class="violet">${item.price}${item.currency}</span>
      </li>
    </ul>
    <br>
    ${this.translate.instant('ADDONS.POPUP_MSG_2', {
      totalAmount: this.totalAmount.toFixed(2) + item.currency
    })}
  `;

    const dialogRef = this.dialog.open(PopupModalComponent, {
      panelClass: 'purchase-addon-modal',
      disableClose: true,
      data: {
        title: this.translate.instant('ADDONS.BUY_2'),
        subTitle: '',
        customHTML: html,
        buttonTitle: this.translate.instant('HOME.MODAL-MARK.BTN-CONFIRM'),
        closeBtnTop: true,
        callbackBtn: 'buy'
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.callback === 'buy') {
        this.purchaseSpinner = true;

        const body: any = {
          userId: this.guiService.userLogged.user.id,
          customerId: this.guiService.userLogged.userPaymentInfo.chargebeePaymentInfo.customerId,
          customerEmail: this.guiService.userLogged.user.email,
          itemPriceIds: [
            {
              item_price_id: item.itemPriceId,
              quantity: item.quantity.count
            }
          ]
        };

        this.restService
          .postService('node', '/purchase-addon', body)
          .subscribe((ris) => {
            this.purchaseSpinner = false;
            this.openModalPaymentResult(ris.success);
          });
      }
    });
  }

  openModalPaymentResult(status: boolean): void {

    const dialogRef = this.dialog.open(PopupModalComponent, {
      panelClass: 'custom-modal',
      disableClose: true, // backdropDismiss: false
      data: {
        icon: status ? 'checkmark-outline' : 'close-outline',
        iconClass: status ? 'green' : 'red',
        title: status
          ? this.translate.instant('ADDONS.PAYMENT_DONE_TITLE')
          : this.translate.instant('ADDONS.PAYMENT_FAILED_TITLE'),
        subTitle: status
          ? this.translate.instant('ADDONS.PAYMENT_DONE_MSG')
          : this.translate.instant('ADDONS.PAYMENT_FAILED_MSG'),
        redirectUrl: 'main/tabs/home',
        buttonTitle: status ? 'Ok' : this.translate.instant('ADDONS.BACK')
      }
    });
  }

}
